import React, { Component, useState } from 'react';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';

import Logo from './Logo';

const ScreenWrapper = styled.div`
  position: absolute;
  display: flex;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  text-align: center;
  transition: opacity 0.4s, visibility -0.3s linear 0.5s;
  align-items: center;
  justify-content: center;
  color: #344f79;
`;

const LogoContainer = styled(Box)`
  min-width: 300px;
`;

const StyledButton = styled(Button)`
  color: #dadfe6;
  border-color: #dadfe6;

  &:hover {
    background-color: transparent;
  }
`;

const ErrorRefresh = () => {
  const [isReloading, setIsReloading] = useState(false);
  const refresh = async () => {
    setIsReloading(true);
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });

    caches.keys().then((keyList) => {
      return Promise.all(
        keyList.map((key) => {
          return caches.delete(key);
        })
      );
    });
    setTimeout(() => {
      setIsReloading(false);
      window.location.reload();
    }, 1000);
  };
  return (
    <ScreenWrapper>
      <Flex flex={1} style={{ maxWidth: '650px' }} flexDirection="column" justifyContent="center" alignItems="center">
        <LogoContainer>
          <Logo dark={false} />
        </LogoContainer>
        <Heading mt={5} fontSize={5}>
          Your Experience Just Got Better!
        </Heading>
        <Text mt={4} mb={5} fontSize={3} style={{ textAlign: 'center' }}>
          We’ve made improvements to enhance your experience.
          <br />
          Please, <b>refresh the page</b> to access the latest version.
        </Text>
        <StyledButton disabled={isReloading} variant="primary" onClick={refresh}>
          {!!isReloading ? 'Refreshing...' : 'Refresh'}
        </StyledButton>
      </Flex>
    </ScreenWrapper>
  );
};

export default ErrorRefresh;
